import { genderOptions } from "src/constants/common";
import { SupportProgramType } from "src/types/supportProgram.types";

export default {
  psp_name: "GoodFlip Care",
  logo_url:
    "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/goodflip-care-program/goodflip-care-logo.png",
  medical_condition_group_id: {
    uat: "0c01eae6-624a-11ec-9077-ab9c0a5eb881",
    prod: "e8e2ba22-a353-11ef-82b3-000d3a3e198b",
  },
  support_program_name: "GoodFlip Care Program",
  support_program_key: "goodflip-care-program",
  program_type: "timeline", // ["cycle", "timeline"]
  loggers: [],
  theme: {
    colors: {
      primary: "#299D6B",
      secondary: "#299D6B",
      primaryHover: "#217A54",
      secondaryHover: "#217A54",
      primaryBackground: "#F0F0F0",
      secondaryBackground: "#F0F0F0",
      background: "#ffffff",
      foreground: "#2d3748",
      shimmerBackground: "#e2e8f0",
      border: "#e2e8f0",
    },
    fonts: {
      primary: "Roboto",
      secondary: "Open Sans",
      tertiary: "Montserrat",
    },
  },
  config: {
    enableWallet: false,
    enableDrugDelivery: false,
    enableDrugClaimJourney: false,
  },
  documents: {
    document_type: "goodflip_care_program_report",
    required_documents: [
      {
        id: "prescription",
        title: "Doctor's Prescription",
        description:
          "Upload your doctor's prescription which mentions the GoodFlip care program",
        required: true,
        supported_file_types: ["pdf", "jpg", "png"],
        max_file_size_in_mb: 10, // 10MB
        document_type: "Prescriptions",
      },
      {
        id: "invoice",
        title: "Purchase Invoice",
        description:
          "Upload your purchase invoice which mentions the medication for which you are availing the program",
        required: false,
        supported_file_types: ["pdf", "jpg", "png"],
        max_file_size_in_mb: 10, // 10MB
        document_type: "Invoice",
      },
    ],
  },
  website: {
    hero_image:
      "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/acti-liv-psp-hero-banner-main.png",
    benefits: {
      title: "Get GoodFlip Care Program for free with every purchase",
      subtitle: "Program Offerings",
      benefits: [
        {
          title: "Free Physio Consultation",
          description: "Get guidance to improve your fitness and mobility",
          image:
            "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/acti-liv-offerings-free-physio-consultation.png",
        },
        {
          title: "Free Nutritionist Consultation",
          description: "Expert advice to help you achieve your health goals",
          image:
            "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/acti-liv-offerings-free-nutri-consultation.png",
        },
        {
          title: "Free GoodFlip Care Strips",
          description: "Support your journey with prescribed medication",
          image:
            "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/acti-liv-offerings-free-lipaglyn-strips.png",
        },
        {
          title: "Free Smart Scale Device",
          description: "Track your progress with a smart body scale",
          image:
            "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/acti-liv-offerings-free-smart-scale-device.png",
        },
      ],
    },
    faqs: {
      title: "FAQ's",
      faqs: [
        {
          question: "How do I access the GoodFlip Care Program?",
          answer:
            "Scan the QR code on your Lipaglyn pack to download the app and activate the program.",
        },
        {
          question: "What benefits do I get with the GoodFlip Care Program?",
          answer:
            "With the GoodFlip Care Program, you get free consultations with a physiotherapist, nutritionist, and success coach, along with complimentary Goodflip Care strips, a smart scale, and expert-curated educational content to support your health journey.",
        },
        {
          question: "How long do the benefits last?",
          answer:
            "The benefits last for 1 month. You can renew your benefits with every new GoodFlip Care purchase.",
        },
        {
          question: "Is my information secure?",
          answer:
            "Yes, your information is completely secure. Protecting your privacy and data is our top priority, and we follow strict safety protocols to keep it safe.",
        },
      ],
    },
    request_call_section: {
      title: "Request a call",
      description:
        "We're here to help you get started. Request a call and we'll get back to you as soon as possible.",
    },
  },
  onboarding: {
    steps: [
      {
        id: "mobile_number_capture",
        title: "Enter your mobile number",
        description: "We'll send a verification code to your mobile number",
        type: "mobile_number",
      },
      {
        id: "otp_capture",
        title: "Enter the verification code",
        description: "We'll send a verification code to your mobile number",
        type: "otp",
      },
      {
        id: "user_type_selection",
        title: "Select your user type",
        description: "We'll send a verification code to your mobile number",
        type: "radio",
        options: [
          {
            id: "patient",
            title: "I am a Patient",
            description: "I am a Patient",
          },
          {
            id: "caregiver",
            title: "I am a Caregiver",
            description: "I am a Caregiver",
          },
        ],
      },
      {
        id: "patient_name_capture",
        title: "What is your name?",
        description: "Please enter the full name as per medical records",
        type: "text",
      },
      {
        id: "patient_gender_selection",
        title: "What is your gender?",
        description: "Please select your gender",
        type: "radio",
        options: genderOptions,
      },
      {
        id: "patient_dob_capture",
        title: "What is your date of birth?",
        description: "This helps us provide age-appropriate care",
        type: "date",
      },
      {
        id: "doctor_details_capture",
        title: "Please provide details of the patient's doctor",
        description:
          "We ask your doctor's details to ensure seamless coordination of your care",
        type: "automated_form", // ["automated_form", "manual_form"]
      },
      {
        id: "upload_documents",
        title: "Upload your documents",
        description: "Please upload the following documents",
        type: "document_upload",
        report_type: "goodflip_care_program_report",
      },
    ],
  },
  app: {
    screens: {
      "home-screen": {
        id: "home-screen",
        title: "Home",
        description: "This is the home screen",
        type: "home",
        icon: "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/house.svg",
        activeIcon:
          "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/house.svg",
        components: [
          {
            id: "hero-section",
            type: "hero",
            title: "Welcome USER_NAME!",
            description: "Welcome to GoodFlip Care",
            background_image_url:
              "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/acti-liv-hero-background.png",
            logo_url:
              "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/goodflip-care-program/goodflip-care-logo.png",
            show_header_items: true,
          },
          {
            id: "today-progress-card",
            type: "card",
            title: "Today's Progress",
            description: "Track your daily wellness goals",
            options: [
              {
                id: "water-logs",
                color: "#3b82f6",
                title: "Water",
              },
              {
                id: "steps-logs",
                color: "#10b981",
                title: "Steps",
              },
              {
                id: "sleep-logs",
                color: "#8b5cf6",
                title: "Sleep",
              },
              {
                id: "diet-logs",
                color: "#3b82f6",
                title: "Diet",
              },
            ],
          },
          {
            id: "reminders-card",
            type: "card",
            title: "Reminders",
            description: "Actions pending your attention",
          },
          {
            id: "services-card",
            type: "card",
            title: "Services",
            description: "Quick access to care services",
            services: [
              {
                id: "book-appointments",
              },
              {
                id: "health-store",
              },
              {
                id: "chat",
              },
              // {
              //   id: "book-lab-tests",
              // },
            ],
          },
          {
            id: "powered-by-logo",
          },
        ],
      },
      "program-screen": {
        id: "program-screen",
        title: "Program",
        description: "This is the program screen",
        type: "program",
        components: [
          {
            id: "hero-section",
            type: "hero",
            title: "Welcome USER_NAME!",
            description: "Welcome to GoodFlip Care",
            background_image_url:
              "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/acti-liv-hero-background.png",
            logo_url:
              "https://aztatvaprodstorage.blob.core.windows.net/goodflip-care/goodflip-care-program/goodflip-care-logo.png",
            show_header_items: false,
          },
          {
            id: "journey-card",
            type: "journey",
            title: "Treatment Journey",
            description: "This is the treatment journey card",
          },
          {
            id: "services-card",
            type: "card",
            title: "Services",
            description: "Quick access to care services",
            services: [
              {
                id: "book-appointments",
              },
              {
                id: "health-store",
              },
              {
                id: "chat",
              },
              // {
              //   id: "book-lab-tests",
              // },
            ],
          },
          // {
          //   id: "health-store-card",
          //   type: "card",
          //   title: "Health Store",
          //   description: "Everything you need for your health journey",
          //   view_all_link: "https://shop.goodflip.in/",
          //   options: [
          //     {
          //       id: "nutraceuticals",
          //       title: "Nutraceuticals",
          //       description: "This is the nutraceuticals card",
          //       link: "https://shop.goodflip.in/collections/supplements",
          //     },
          //   ],
          // },
          {
            id: "educational-content-card",
            type: "card",
            title: "Educational Content",
            description: "Personalized health tips for your health journey",
          },
          {
            id: "powered-by-logo",
          },
        ],
      },
      "health-assistant-screen": {
        id: "health-assistant-screen",
        title: "Health Assistant Screen",
        description: "This is the chat screen",
        type: "health-assistant-screen",
      },
      "insights-screen": {
        id: "insights-screen",
        title: "Insights",
        description: "This is the insights screen",
        type: "insights",
        // tabs are present will code in page(web) - based on condition we will rendet the tabs. Ex: lab test is present then we will show the lab test tab.
        logs: [
          {
            id: "medication-logs",
            icon: "Medication",
            title: "Medication Logs",
            description: "Track your medication schedule and adherence",
          },
          {
            id: "water-logs",
            icon: "Droplets",
            title: "Water Logs",
            description: "Track your daily water intake to stay hydrated",
          },
          {
            id: "sleep-logs",
            icon: "Sleep",
            title: "Sleep Logs",
            description:
              "Track your sleep duration to improve rest and overall well-being",
          },
          {
            id: "steps-logs",
            icon: "Steps",
            title: "Steps Logs",
            description: "Track your step count over time",
          },
          {
            id: "exercise-logs",
            icon: "Exercise",
            title: "Exercise Logs",
            description: "Track your workouts and physical activities",
          },
          // {
          //   id: "fatigue-logs",
          //   icon: "Fatigue",
          //   title: "Fatigue Logs",
          //   description:
          //     "Track your daily fatigue levels to identify patterns and triggers.",
          // },
          // {
          //   id: "menstruation-logs",
          //   icon: "Menstruation",
          //   title: "Menstruation Logs",
          //   description: "Track your menstrual cycle patterns and symptoms.",
          // },
          {
            id: "diet-logs",
            icon: "Diet",
            title: "Diet Logs",
            description: "Track your nutrition intake and dietary patterns",
          },
        ],
      },
      "records-screen": {
        id: "records-screen",
        title: "Records",
        description: "This is the records screen",
        type: "records",
      },
    },
  },
} satisfies SupportProgramType;
